import FdAdoptionPage from "@faire/prototype-playground/workspace/bc/fd-adoption";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const AudiencesPage = lazy(
  () => import("@faire/prototype-playground/workspace/bc/audiences")
);

const CustomerProfilePage = lazy(
  () => import("@faire/prototype-playground/workspace/bc/customer-profile")
);

const CustomersTableBrandRefinementPage = lazy(
  () =>
    import("@faire/prototype-playground/workspace/bc/customers-table-brand-refinement")
);

export function BenjaminChaconRoutes() {
  return (
    <Switch>
      <Route path="/bc/audiences" component={AudiencesPage} />
      <Route path="/bc/customer-profile" component={CustomerProfilePage} />
      <Route
        path="/bc/customers-table-brand-refinement"
        component={CustomersTableBrandRefinementPage}
      />
      <Route path="/bc/fd-adoption" component={FdAdoptionPage} />
    </Switch>
  );
}

export const slug = "bc";
